module.exports = __webpack_public_path__ + "img/upcommingEvents1.b7a12144.jpg";